var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.9,
    height: 17.5,
    viewBox: "0 0 15.9 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_751",
    "data-name": "Trac\\xE9 751",
    d: "M161.7,541.625a4,4,0,1,1,4-4A4,4,0,0,1,161.7,541.625Zm-7.2,6.4v.8a.8.8,0,0,0,.8.8h12.8a.8.8,0,0,0,.8-.8v-.8a3.2,3.2,0,0,0-3.2-3.2h-8A3.2,3.2,0,0,0,154.5,548.025Z",
    transform: "translate(-153.75 -532.875)",
    fill: "none",
    stroke: "#19c3b9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9fbc80640e049851e96dc187c9f03f02.svg";
export { ForwardRef as ReactComponent };